module.exports = __webpack_public_path__ + "img/9-3.019f743e.png";